export default {
    alert: "<div class='alert alert-dismissible bg-body d-flex align-items-center py-2 ps-2'>\n\
                <div class='alert-message order-1'>\n\
                </div>\n\
                <button type='button' class='btn-close' data-bs-dismiss='alert' aria-label='Close'></button>\n\
            </div>",
    options: {
        expires: 2000,
        create_callback:null,
        parentTo:null,
        replaceWithId:null,
        id:null,
        icon_html: {
            "success":"<span class='material-symbols-outlined fs-lg order-0'>check_circle</span> ",
            "info":"<span class='material-symbols-outlined fs-lg'>info</span> ",
            "warning":"<span class='material-symbols-outlined fs-lg'>warning</span> ",
            "danger":"<span class='material-symbols-outlined fs-lg'>error</span> "
        }
    },
    
    /**
     * 
     * @param {type} text
     * @param {type} alert_type
     * @param {type} options
     */
    add: function(text,alert_type,options) {

        var $alert = $(this.alert);
        $alert.first()
            .addClass("alert-"+alert_type+"")
            .find(".alert-message")
            .append(text);

        if(this.options.icon_html[alert_type] !== undefined) {
            $alert.first().prepend(this.options.icon_html[alert_type]);
        }
        
        var removeBR = false;

        var opts = $.extend({},this.options,options);
        if(!opts.parentTo) {
            opts.parentTo = $("#messages");
        } else {
            removeBR = true;
        }
        
        if(opts.id !== null) {
            $(opts.parentTo).find(".alert[data-id='"+opts.id+"']").remove();
        }
        
        if(opts.id !== null) {
            $alert.attr("data-id",opts.id);
        }
        
        if(opts.expires !== 0) {
            $alert.find("button").remove();

            $alert.first().addClass("out");
            setTimeout(function(){
                $alert.removeClass("out").addClass('in');
            },250);

            $alert.timeout = setTimeout(function(){
                $alert.addClass('exit');
            },opts.expires);

            $alert.on('animationend',function(e){
                $alert.remove();
            });
            
            $alert.on("mouseenter",function(){
                clearTimeout($alert.timeout);
            });
            $alert.on("mouseleave",function(){
                $alert.timeout = setTimeout(function(){
                    $alert.addClass('exit');
                },opts.expires);
            });
        }
        
        $(opts.parentTo).append($alert);
        
        if(opts.create_callback !== null) {
            opts.create_callback($alert);
        }

        if(!removeBR) {
            $alert.after("<br>");
        }
        
    }
    
}